/**
 * @generated SignedSource<<9dd3d7c4f2b1a5383b7148d7defd7deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeTxnsInputObject = {
  name?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type needsReviewPage_AttributeTxnsMutation$variables = {
  input: AttributeTxnsInputObject;
};
export type needsReviewPage_AttributeTxnsMutation$data = {
  readonly attributeTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly suggestion: {
      readonly additionalCount: number;
      readonly matchKind: string;
      readonly regex: string;
      readonly totalCount: number;
    } | null | undefined;
  } | null | undefined;
};
export type needsReviewPage_AttributeTxnsMutation = {
  response: needsReviewPage_AttributeTxnsMutation$data;
  variables: needsReviewPage_AttributeTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regex",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchKind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "needsReviewPage_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "needsReviewPage_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9dea7b0ab9264e1319f607232a532a6c",
    "id": null,
    "metadata": {},
    "name": "needsReviewPage_AttributeTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation needsReviewPage_AttributeTxnsMutation(\n  $input: AttributeTxnsInputObject!\n) {\n  attributeTxns(input: $input) {\n    stakeholder {\n      id\n      name\n    }\n    suggestion {\n      regex\n      matchKind\n      additionalCount\n      totalCount\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3578c2e4990208e69ac2c365c1355395";

export default node;
